import { createTokensFromScale } from '../../utils/createTokensFromScale';
export const defaultFontSizeScale = {
    prefix: 'twist-core-font-size',
    steps: {
        base: { size: 1, unit: 'rem' },
        12: { multiplier: 0.75 },
        14: { multiplier: 0.875 },
        16: { multiplier: 1 },
        18: { multiplier: 1.125 },
        20: { multiplier: 1.25 },
        24: { multiplier: 1.5 },
        28: { multiplier: 1.75 },
        34: { multiplier: 2.125 },
        36: { multiplier: 2.25 },
        40: { multiplier: 2.5 },
        48: { multiplier: 3 },
        96: { multiplier: 6 }
    }
};
// generates the following tokens:
// export const defaultFontSizeTokens = {
//   'twist-core-font-size-base': '1rem',
//   'twist-core-font-size-12': 'calc(0.75 * var(--twist-core-font-size-base))',
//   'twist-core-font-size-14': 'calc(0.875 * var(--twist-core-font-size-base))',
//   'twist-core-font-size-16': 'calc(1 * var(--twist-core-font-size-base))',
//   'twist-core-font-size-18': 'calc(1.125 * var(--twist-core-font-size-base))',
//   'twist-core-font-size-20': 'calc(1.25 * var(--twist-core-font-size-base))',
//   'twist-core-font-size-24': 'calc(1.5 * var(--twist-core-font-size-base))',
//   'twist-core-font-size-28': 'calc(1.75 * var(--twist-core-font-size-base))',
//   'twist-core-font-size-34': 'calc(2.125 * var(--twist-core-font-size-base))',
//   'twist-core-font-size-36': 'calc(2.25 * var(--twist-core-font-size-base))',
//   'twist-core-font-size-40': 'calc(2.5 * var(--twist-core-font-size-base))',
//   'twist-core-font-size-48': 'calc(3 * var(--twist-core-font-size-base))',
//   'twist-core-font-size-96': 'calc(6 * var(--twist-core-font-size-base))'
// }
export const defaultFontSizeTokens = createTokensFromScale(defaultFontSizeScale);
